/* A2-URUN · Ürün sayfası davranışları.
   Sözleşme: window.Tema.sepeteEkle(items) (base.js) — yoksa /cart/add.js + cart:refresh / cart:open yedeği. */
(function () {
  'use strict';

  function sepeteEkle(items) {
    if (window.Tema && typeof window.Tema.sepeteEkle === 'function') {
      return Promise.resolve(window.Tema.sepeteEkle(items, { sessiz: true }));
    }
    return fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) {
        return r.json().then(function (veri) {
          if (!r.ok) throw veri;
          return veri;
        });
      })
      .then(function (veri) {
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        document.dispatchEvent(new CustomEvent('cart:open'));
        return veri;
      });
  }

  function Urun(kok) {
    this.kok = kok;
    this.sectionId = kok.dataset.sectionId;
    this.url = kok.dataset.urunUrl;
    var json = kok.querySelector('[data-urun-json]');
    this.veri = json ? JSON.parse(json.textContent) : { variants: [], metinler: {} };
    this.metin = this.veri.metinler || {};
    this.form = kok.querySelector('[data-urun-form]');
    this.idInput = kok.querySelector('[data-varyant-id]');
    this.mesaj = kok.querySelector('[data-sepet-mesaj]');
    var buton = kok.querySelector('[data-sepete-ekle] [data-buton-metin]');
    this.butonMetni = buton ? buton.textContent.trim() : this.metin.ekle;
    this.istek = null;

    this.galeri();
    this.varyant();
    this.sepet();
    this.adet();
    this.sabitCubuk();
    this.sekmeler();
  }

  /* ---------- Galeri ---------- */
  Urun.prototype.galeri = function () {
    var self = this;
    this.ana = this.kok.querySelector('[data-galeri-ana]');
    if (!this.ana) return;
    this.slaytlar = Array.prototype.slice.call(this.ana.children);
    this.sira = this.kok.querySelector('[data-galeri-sira]');

    this.kok.querySelectorAll('[data-galeri-sec]').forEach(function (btn) {
      btn.addEventListener('click', function () { self.gorselSec(btn.dataset.galeriSec, true); });
    });

    if ('IntersectionObserver' in window && this.slaytlar.length > 1) {
      var io = new IntersectionObserver(function (girdiler) {
        girdiler.forEach(function (g) {
          if (g.isIntersecting && g.intersectionRatio > 0.6 && self.sira) {
            self.sira.textContent = Number(g.target.dataset.index) + 1;
          }
        });
      }, { root: this.ana, threshold: [0.6] });
      this.slaytlar.forEach(function (s) { io.observe(s); });
    }

    this.ana.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
      var aktif = self.ana.querySelector('.is-active') || self.slaytlar[0];
      var i = self.slaytlar.indexOf(aktif) + (e.key === 'ArrowRight' ? 1 : -1);
      if (i < 0 || i >= self.slaytlar.length) return;
      e.preventDefault();
      self.gorselSec(self.slaytlar[i].dataset.mediaId, true);
    });
  };

  Urun.prototype.gorselSec = function (mediaId, kaydir) {
    if (!this.ana || !mediaId) return;
    var hedef = null;
    this.slaytlar.forEach(function (s) {
      var esit = s.dataset.mediaId === String(mediaId);
      s.classList.toggle('is-active', esit);
      if (esit) hedef = s;
    });
    if (!hedef) return;
    this.kok.querySelectorAll('[data-galeri-sec]').forEach(function (b) {
      var esit = b.dataset.galeriSec === String(mediaId);
      b.classList.toggle('is-active', esit);
      if (esit) b.setAttribute('aria-current', 'true');
      else b.removeAttribute('aria-current');
    });
    if (this.sira) this.sira.textContent = Number(hedef.dataset.index) + 1;
    // Mobilde kaydırmalı şerit: ilgili slayta kaydır.
    if (kaydir !== false && this.ana.scrollWidth > this.ana.clientWidth) {
      var azHareket = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.ana.scrollTo({ left: hedef.offsetLeft - this.ana.offsetLeft, behavior: azHareket ? 'auto' : 'smooth' });
    }
  };

  /* ---------- Varyant ---------- */
  Urun.prototype.varyant = function () {
    var self = this;
    this.secici = this.kok.querySelector('[data-varyant-secici]');
    if (!this.secici) return;
    this.secici.addEventListener('change', function () { self.varyantDegisti(); });
    this.uygunlukIsaretle();
  };

  Urun.prototype.seciliDegerler = function () {
    var degerler = [];
    this.secici.querySelectorAll('fieldset').forEach(function (fs) {
      var secili = fs.querySelector('input:checked');
      degerler.push(secili ? secili.value : null);
      var etiket = fs.querySelector('[data-secili-deger]');
      if (etiket && secili) etiket.textContent = secili.value;
    });
    return degerler;
  };

  Urun.prototype.varyantBul = function (degerler) {
    return this.veri.variants.find(function (v) {
      return v.options.every(function (o, i) { return o === degerler[i]; });
    });
  };

  // Diğer seçimler sabitken satın alınamayan değerleri soluk göster (gizleme yok).
  Urun.prototype.uygunlukIsaretle = function () {
    var self = this;
    var degerler = this.seciliDegerler();
    this.secici.querySelectorAll('input[data-secenek-index]').forEach(function (inp) {
      var i = Number(inp.dataset.secenekIndex);
      var deneme = degerler.slice();
      deneme[i] = inp.value;
      var v = self.varyantBul(deneme);
      inp.closest('label').classList.toggle('is-yok', !v || !v.available);
    });
  };

  Urun.prototype.varyantDegisti = function () {
    var degerler = this.seciliDegerler();
    var v = this.varyantBul(degerler);
    this.uygunlukIsaretle();
    this.butonDurumu(v);
    this.kisiselGuncelle(v);
    if (!v) return;

    if (this.idInput) this.idInput.value = v.id;
    if (v.featured_media) this.gorselSec(v.featured_media, true);
    if (window.history && window.history.replaceState) {
      window.history.replaceState({}, '', this.url + '?variant=' + v.id);
    }
    this.bolumYenile(v.id);
  };

  // Fiyat, kademe ve buton alanlarını Section Rendering API ile sunucudan tazele (fiyat hesabı temada yapılmaz).
  Urun.prototype.bolumYenile = function (variantId) {
    var self = this;
    if (this.istek) this.istek.abort();
    this.istek = new AbortController();
    var kademe = this.kok.querySelector('[data-kademe] input:checked');
    var seciliAdet = kademe ? kademe.value : null;

    fetch(this.url + '?variant=' + variantId + '&section_id=' + encodeURIComponent(this.sectionId), { signal: this.istek.signal })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var yeni = new DOMParser().parseFromString(html, 'text/html');
        self.kok.querySelectorAll('[data-yenile][id]').forEach(function (eski) {
          var kaynak = yeni.getElementById(eski.id);
          if (kaynak) eski.innerHTML = kaynak.innerHTML;
        });
        if (seciliAdet) {
          var geri = self.kok.querySelector('[data-kademe] input[value="' + seciliAdet + '"]');
          if (geri) geri.checked = true;
        }
        var v = self.veri.variants.find(function (x) { return String(x.id) === String(variantId); });
        self.butonDurumu(v);
      })
      .catch(function (e) { if (e.name !== 'AbortError') console.warn('[urun] bölüm yenilenemedi', e); });
  };

  // Varyant koşullu kişiselleştirme alanları: eşleşmeyen gizlenir ve disabled olur (gönderilmez, doğrulanmaz).
  Urun.prototype.kisiselGuncelle = function (v) {
    var secili = v ? v.options.map(function (o) { return String(o).trim().toLowerCase(); }) : [];
    this.kok.querySelectorAll('[data-kisisel]').forEach(function (kap) {
      var kosul = (kap.dataset.varyantDegeri || '').trim();
      var goster = true;
      if (kosul) {
        var degerler = kosul.split(',').map(function (d) { return d.trim().toLowerCase(); }).filter(Boolean);
        goster = degerler.some(function (d) { return secili.indexOf(d) !== -1; });
      }
      kap.hidden = !goster;
      kap.querySelectorAll('[data-kisisel-alan]').forEach(function (alan) { alan.disabled = !goster; });
    });
  };

  Urun.prototype.ozellikler = function () {
    var ozellik = {};
    var var_ = false;
    this.kok.querySelectorAll('[data-kisisel-alan]').forEach(function (alan) {
      if (alan.disabled) return;
      var deger = alan.value.trim();
      var m = alan.name.match(/^properties\[(.*)\]$/);
      if (!deger || !m) return;
      ozellik[m[1]] = deger;
      var_ = true;
    });
    return var_ ? ozellik : null;
  };

  Urun.prototype.butonDurumu = function (v) {
    var metin = !v ? this.metin.yok : v.available ? this.butonMetni : this.metin.tukendi;
    var pasif = !v || !v.available;
    this.kok.querySelectorAll('[data-sepete-ekle]').forEach(function (b) {
      b.disabled = pasif;
      var m = b.querySelector('[data-buton-metin]');
      if (m) m.textContent = metin;
    });
    var sabit = this.kok.querySelector('[data-sabit-ekle]');
    if (sabit) sabit.disabled = pasif;
  };

  /* ---------- Adet seçici: − / + ve toplam tutar ---------- */
  Urun.prototype.adet = function () {
    var self = this;
    var kap = this.kok.querySelector('[data-adet]');
    if (!kap) return;
    var girdi = kap.querySelector('[data-adet-girdi]');
    var toplam = kap.querySelector('[data-adet-toplam]');
    var en_cok = parseInt(girdi.max, 10) || 50;
    var para = new Intl.NumberFormat('tr-TR', { style: 'currency', currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'TRY', maximumFractionDigits: 0 });

    function oku() {
      var n = parseInt(girdi.value, 10);
      if (isNaN(n) || n < 1) n = 1;
      if (n > en_cok) n = en_cok;
      return n;
    }
    function fiyat() {
      var id = self.idInput ? String(self.idInput.value) : '';
      var v = self.veri.variants.find(function (x) { return String(x.id) === id; });
      return v ? v.price : parseInt(kap.dataset.fiyat, 10);
    }
    function yaz() {
      girdi.value = oku();
      if (toplam) toplam.textContent = para.format((fiyat() * oku()) / 100);
    }
    kap.querySelector('[data-adet-azalt]').addEventListener('click', function () { girdi.value = oku() - 1; yaz(); });
    kap.querySelector('[data-adet-artir]').addEventListener('click', function () { girdi.value = oku() + 1; yaz(); });
    girdi.addEventListener('input', yaz);
    girdi.addEventListener('change', yaz);
    this.kok.addEventListener('change', function (e) { if (e.target.closest && e.target.closest('[data-varyant-secici]')) setTimeout(yaz, 0); });
    yaz();
  };

  /* ---------- Sepete ekle (ana ürün × kademe + işaretli ek ürünler) ---------- */
  Urun.prototype.sepet = function () {
    var self = this;
    if (!this.form) return;
    this.form.addEventListener('submit', function (e) {
      e.preventDefault();
      self.ekle();
    });
  };

  // Yerel doğrulamayı (zorunlu alanlar) çalıştırarak gönder; geçerse submit olayı ekle()'yi çağırır.
  Urun.prototype.gonder = function () {
    if (!this.form) return;
    var buton = this.form.querySelector('[data-sepete-ekle]');
    if (typeof this.form.requestSubmit === 'function') this.form.requestSubmit(buton || undefined);
    else if (this.form.reportValidity()) this.ekle();
  };

  Urun.prototype.ekle = function () {
    var self = this;
    var buton = this.kok.querySelector('[data-sepete-ekle]');
    if (!buton || buton.disabled || buton.getAttribute('aria-busy') === 'true') return;

    var kademe = this.kok.querySelector('[data-kademe] input:checked');
    var adet = kademe ? parseInt(kademe.value, 10) : 1;
    var girdi = this.kok.querySelector('[data-adet-girdi]');
    if (girdi) adet = parseInt(girdi.value, 10);
    var ana = { id: Number(this.idInput.value), quantity: adet > 0 ? adet : 1 };
    var ozellik = this.ozellikler();
    if (ozellik) ana.properties = ozellik; // yalnız ana ürüne; ek ürünlere eklenmez
    var items = [ana];
    this.kok.querySelectorAll('[data-ek-urun]:checked').forEach(function (cb) {
      items.push({ id: Number(cb.value), quantity: 1 });
    });

    var metinEl = buton.querySelector('[data-buton-metin]');
    buton.setAttribute('aria-busy', 'true');
    if (metinEl) metinEl.textContent = this.metin.ekleniyor;
    this.mesajYaz('', false);

    sepeteEkle(items)
      .then(function () {
        self.mesajYaz(self.metin.eklendi, false);
        self.kok.querySelectorAll('[data-ek-urun]:checked').forEach(function (cb) { cb.checked = false; });
      })
      .catch(function (hata) {
        var m = (hata && (hata.description || hata.message)) || self.metin.hata;
        self.mesajYaz(typeof m === 'string' ? m : self.metin.hata, true);
      })
      .then(function () {
        buton.removeAttribute('aria-busy');
        if (metinEl) metinEl.textContent = self.butonMetni;
      });
  };

  Urun.prototype.mesajYaz = function (metin, hata) {
    if (!this.mesaj) return;
    this.mesaj.textContent = metin || '';
    this.mesaj.classList.toggle('is-hata', !!hata);
  };

  /* ---------- Mobil sabit çubuk: ana buton ekranın üstünden çıkınca görünür ---------- */
  Urun.prototype.sabitCubuk = function () {
    var self = this;
    var cubuk = this.kok.querySelector('[data-sabit-cubuk]');
    var hedef = this.form;
    if (!cubuk || !hedef || !('IntersectionObserver' in window)) return;

    var io = new IntersectionObserver(function (girdiler) {
      var g = girdiler[0];
      var goster = !g.isIntersecting && g.boundingClientRect.top < 0;
      cubuk.classList.toggle('is-gorunur', goster);
      cubuk.setAttribute('aria-hidden', goster ? 'false' : 'true');
      if (goster) cubuk.removeAttribute('inert');
      else cubuk.setAttribute('inert', '');
    });
    io.observe(hedef);

    var dugme = cubuk.querySelector('[data-sabit-ekle]');
    if (dugme) dugme.addEventListener('click', function () { self.gonder(); });
  };

  /* ---------- Sekmeler (WAI-ARIA tabs) ---------- */
  Urun.prototype.sekmeler = function () {
    this.kok.querySelectorAll('[data-sekmeler]').forEach(function (kap) {
      var dugmeler = Array.prototype.slice.call(kap.querySelectorAll('[role="tab"]'));
      function sec(d, odakla) {
        dugmeler.forEach(function (x) {
          var aktif = x === d;
          x.setAttribute('aria-selected', aktif ? 'true' : 'false');
          x.tabIndex = aktif ? 0 : -1;
          var p = document.getElementById(x.getAttribute('aria-controls'));
          if (p) p.hidden = !aktif;
        });
        if (odakla) d.focus();
      }
      dugmeler.forEach(function (d, i) {
        d.addEventListener('click', function () { sec(d, false); });
        d.addEventListener('keydown', function (e) {
          var j = null;
          if (e.key === 'ArrowRight') j = (i + 1) % dugmeler.length;
          else if (e.key === 'ArrowLeft') j = (i - 1 + dugmeler.length) % dugmeler.length;
          else if (e.key === 'Home') j = 0;
          else if (e.key === 'End') j = dugmeler.length - 1;
          if (j === null) return;
          e.preventDefault();
          sec(dugmeler[j], true);
        });
      });
    });
  };

  function baslat(kapsam) {
    (kapsam || document).querySelectorAll('[data-urun]').forEach(function (kok) {
      if (kok.__urun) return;
      kok.__urun = new Urun(kok);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { baslat(); });
  else baslat();
  document.addEventListener('shopify:section:load', function (e) { baslat(e.target); });
})();
